"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInactiveListener = exports.useEagerConnect = exports.useDisconnect = exports.useTryConnect = exports.useActiveWeb3 = exports.useNetworkWeb3 = exports.useUserWeb3 = void 0;
var react_1 = require("react");
var core_1 = require("@web3-react/core");
var walletconnect_connector_1 = require("@web3-react/walletconnect-connector");
var misc_1 = require("../constants/misc");
var user_agent_1 = require("../utils/user-agent");
var useUserWeb3 = function () {
    var context = (0, core_1.useWeb3React)();
    return context;
};
exports.useUserWeb3 = useUserWeb3;
var useNetworkWeb3 = function () {
    var context = (0, core_1.useWeb3React)(misc_1.NETWORK_CONTEXT_NAME);
    return context;
};
exports.useNetworkWeb3 = useNetworkWeb3;
var useActiveWeb3 = function () {
    var user = (0, exports.useUserWeb3)();
    var network = (0, exports.useNetworkWeb3)();
    return user.active ? user : network;
};
exports.useActiveWeb3 = useActiveWeb3;
var useTryConnect = function () {
    var activate = (0, exports.useUserWeb3)().activate;
    var tryConnect = (0, react_1.useCallback)(function (connector) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (connector && connector instanceof walletconnect_connector_1.WalletConnectConnector) {
                connector.walletConnectProvider = undefined;
            }
            return [2 /*return*/, activate(connector, undefined, true).catch(function (error) {
                    if (error instanceof core_1.UnsupportedChainIdError) {
                        // a little janky...can't use setError because the connector isn't set
                        activate(connector);
                    }
                    else {
                        throw error;
                    }
                })];
        });
    }); }, [activate]);
    return tryConnect;
};
exports.useTryConnect = useTryConnect;
var useDisconnect = function (confirm) {
    var _a = (0, exports.useUserWeb3)(), deactivate = _a.deactivate, connector = _a.connector;
    var disconnect = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var sure;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (confirm ? confirm() : Promise.resolve(true))];
                case 1:
                    sure = _a.sent();
                    if (!sure)
                        return [2 /*return*/];
                    if (connector && connector instanceof walletconnect_connector_1.WalletConnectConnector) {
                        connector.close();
                    }
                    deactivate();
                    return [2 /*return*/];
            }
        });
    }); }, [deactivate, confirm, connector]);
    return disconnect;
};
exports.useDisconnect = useDisconnect;
var useEagerConnect = function (injected, autoConnect) {
    var _a = (0, exports.useUserWeb3)(), activate = _a.activate, active = _a.active;
    var _b = __read((0, react_1.useState)(false), 2), tried = _b[0], setTried = _b[1];
    // try connecting to an injected connector(eg: metamask)
    (0, react_1.useEffect)(function () {
        if (injected && window.ethereum) {
            if (!active && user_agent_1.isMobile) {
                activate(injected, undefined, true).catch(function () {
                    setTried(true);
                });
            }
            else if (autoConnect) {
                injected.isAuthorized().then(function (isAuthorized) {
                    if (isAuthorized) {
                        activate(injected, undefined, true).catch(function () {
                            setTried(true);
                        });
                    }
                    else {
                        setTried(true);
                    }
                });
            }
            else {
                setTried(true);
            }
        }
        else {
            setTried(true);
        }
    }, [activate, active, injected, autoConnect]);
    // wait until we get confirmation of a connection to flip the flag
    (0, react_1.useEffect)(function () {
        if (active)
            setTried(true);
    }, [active]);
    return tried;
};
exports.useEagerConnect = useEagerConnect;
/**
 * Use for network and injected - logs user in
 * and out after checking what network theyre on
 */
var useInactiveListener = function (injected, suppress) {
    if (suppress === void 0) { suppress = false; }
    var _a = (0, exports.useUserWeb3)(), active = _a.active, error = _a.error, activate = _a.activate;
    (0, react_1.useEffect)(function () {
        var ethereum = window.ethereum;
        if (injected && ethereum && ethereum.on && !active && !error && !suppress) {
            var handleChainChanged_1 = function () {
                // eat errors
                activate(injected, undefined, true).catch(function (error) {
                    console.error('Failed to activate after chain changed', error);
                });
            };
            var handleAccountsChanged_1 = function (accounts) {
                if (accounts.length > 0) {
                    // eat errors
                    activate(injected, undefined, true).catch(function (error) {
                        console.error('Failed to activate after accounts changed', error);
                    });
                }
            };
            ethereum.on('chainChanged', handleChainChanged_1);
            ethereum.on('accountsChanged', handleAccountsChanged_1);
            return function () {
                if (ethereum.removeListener) {
                    ethereum.removeListener('chainChanged', handleChainChanged_1);
                    ethereum.removeListener('accountsChanged', handleAccountsChanged_1);
                }
            };
        }
        return undefined;
    }, [active, error, suppress, activate, injected]);
};
exports.useInactiveListener = useInactiveListener;
